import { clientId, sdsManagementPath } from "./constants";
import {
  isProductComplianceControlledProofAuthorized,
  isProductCompliancePolicyAdministratorAuthorized,
} from "./hooks/productComplianceAuth";

const controlledProofRouteGuard = () =>
  isProductComplianceControlledProofAuthorized() ? true : { name: "home" };
const policyAdministrationRouteGuard = () =>
  isProductCompliancePolicyAdministratorAuthorized() ? true : { name: "home" };

export const productComplianceRoutes = [
  {
    path: sdsManagementPath,
    name: "productComplianceSdsInbox",
    component: () => import("./views/SdsInboxView.vue"),
    beforeEnter: controlledProofRouteGuard,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavApplication",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavDashboard",
          route: { name: "productComplianceSdsInbox" },
        },
      ],
    },
  },
  {
    path: `${sdsManagementPath}/documents/:documentId`,
    name: "productComplianceSdsDocument",
    component: () => import("./views/SdsDocumentDetailView.vue"),
    beforeEnter: controlledProofRouteGuard,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavApplication",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavDashboard",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsDocumentTitle",
          route: { name: "productComplianceSdsDocument" },
        },
      ],
    },
  },
  {
    path: `${sdsManagementPath}/policies`,
    name: "productComplianceSdsPolicies",
    component: () => import("./views/SdsPolicyAdministrationView.vue"),
    beforeEnter: policyAdministrationRouteGuard,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavApplication",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavDashboard",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavPolicies",
          route: { name: "productComplianceSdsPolicies" },
        },
      ],
    },
  },
  {
    path: `${sdsManagementPath}/reassessments`,
    name: "productComplianceSdsReassessments",
    component: () => import("./views/SdsReassessmentQueueView.vue"),
    beforeEnter: policyAdministrationRouteGuard,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavApplication",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavReassessments",
          route: { name: "productComplianceSdsReassessments" },
        },
      ],
    },
  },
  {
    path: `${sdsManagementPath}/materials`,
    name: "productComplianceMaterials",
    component: () => import("./views/SdsMaterialListView.vue"),
    beforeEnter: controlledProofRouteGuard,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavApplication",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavDashboard",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavMaterials",
          route: { name: "productComplianceMaterials" },
        },
      ],
    },
  },
  {
    path: `${sdsManagementPath}/materials/:materialUuid`,
    name: "productComplianceMaterial",
    component: () => import("./views/SdsMaterialDetailView.vue"),
    beforeEnter: controlledProofRouteGuard,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavApplication",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavDashboard",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavMaterials",
          route: { name: "productComplianceMaterials" },
        },
        {
          label: "sdsMaterialWorkspace",
          route: { name: "productComplianceMaterial" },
        },
      ],
    },
  },
  {
    path: `${sdsManagementPath}/suppliers`,
    name: "productComplianceSuppliers",
    component: () => import("./views/SdsSupplierListView.vue"),
    beforeEnter: controlledProofRouteGuard,
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "sdsNavApplication",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavDashboard",
          route: { name: "productComplianceSdsInbox" },
        },
        {
          label: "sdsNavSuppliers",
          route: { name: "productComplianceSuppliers" },
        },
      ],
    },
  },
];
